export default __webpack_public_path__ + "static/vivalavida-9df9524227bf8f0aa2d09fc8229513bf.png";